import { getDefaultBaseFieldValue } from 'wbs-components-lib';

export const VIP_WHEEL_SETTINGS_DEFAULT_VALUES = {
  spinResetHours: 13,
  defaultSpinsNumber: 1,
  defaultRewardsMap: [],
  defaultCryptocheckLinks: [getDefaultBaseFieldValue()],
  diamondSpinsNumber: 2,
  diamondRewardsMap: [],
  diamondCryptocheckLinks: [getDefaultBaseFieldValue()],
  eliteSpinsNumber: 3,
  eliteRewardsMap: [],
  eliteCryptocheckLinks: [getDefaultBaseFieldValue()],
};
